import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TQualifier {
  code: string;
  name: string;
  valid: boolean;
  description: string;
  sqlValidation: string;
  maxNumber: string;
  internalMark: string;
  visiblePublic: boolean;
  qualifierGroupCode: string;
}

export interface IQualifier extends TQualifier {}

const Qualifier = Model(
  (model: IQualifier): IQualifier => {
    const _qualifier: TQualifier = Object.assign({}, model);

    let create = (qualifier: IQualifier): IQualifier => {
      let obj = ValidatableObject(qualifier);
      return obj;
    };

    let qualifier = {
      get code() {
        return _qualifier.code;
      },
      set code(value) {
        _qualifier.code = value;
      },
      get name() {
        return _qualifier.name;
      },
      set name(value) {
        _qualifier.name = value;
      },
      get valid() {
        return _qualifier.valid;
      },
      set valid(value) {
        _qualifier.valid = value;
      },
      get description() {
        return _qualifier.description;
      },
      set description(value) {
        _qualifier.description = value;
      },
      get sqlValidation() {
        return _qualifier.sqlValidation;
      },
      set sqlValidation(value) {
        _qualifier.sqlValidation = value;
      },
      get maxNumber() {
        return _qualifier.maxNumber;
      },
      set maxNumber(value) {
        _qualifier.maxNumber = value;
      },
      get internalMark() {
        return _qualifier.internalMark;
      },
      set internalMark(value) {
        _qualifier.internalMark = value;
      },
      get visiblePublic() {
        return _qualifier.visiblePublic;
      },
      set visiblePublic(value) {
        _qualifier.visiblePublic = value;
      },
      get qualifierGroupCode() {
        return _qualifier.qualifierGroupCode;
      },
      set qualifierGroupCode(value) {
        _qualifier.qualifierGroupCode = value;
      }
    };

    return create(qualifier);
  }
);

export default Qualifier;
